import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CalendarRange } from 'lucide-react';

// Admin: platform appointment volume per month (counterpart to the revenue trend).
const AppointmentsTrend = ({ appointmentsTrend, loading }) => {
  const { t } = useTranslation('dashboard');
  const data = (Array.isArray(appointmentsTrend?.data) ? appointmentsTrend.data : []).map((d) => ({
    label: d.monthName ? String(d.monthName).slice(0, 3) : String(d.month ?? ''),
    count: Number(d.count) || 0,
    completed: Number(d.completed) || 0,
  }));
  const hasData = data.some((d) => d.count > 0);

  return (
    <div className="bg-white w-full rounded-xl p-4 border border-gray-200/50 shadow-md" data-testid="admin-appointments-trend">
      <h3 className="text-base sm:text-lg font-bold text-gray-900 flex items-center mb-3">
        <CalendarRange className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-[#4ABDBD]" />
        {t('dashboard.appointments_over_time', 'Appointments over time')}
      </h3>
      {loading ? (
        <p className="text-sm text-gray-400 py-8 text-center">{t('dashboard.loading', 'Loading...')}</p>
      ) : !hasData ? (
        <p className="text-sm text-gray-400 py-8 text-center">{t('dashboard.no_data', 'No data for this period')}</p>
      ) : (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
            <XAxis dataKey="label" tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 12, fill: '#6b7280' }} allowDecimals={false} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: 'rgba(74,189,189,0.08)' }} />
            <Bar dataKey="count" name={t('dashboard.appointments_tab', 'Appointments')} fill="#4ABDBD" radius={[4, 4, 0, 0]} maxBarSize={48} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default AppointmentsTrend;
